import React from "react";

interface Props {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

const Pagination: React.FC<Props> = ({ currentPage, totalPages, onPageChange }) => {
  const getVisiblePages = (current: number, total: number, delta = 1) => {
    const pages: (number | "...")[] = [];

    for (let i = 0; i < total; i++) {
      if (i === 0 || i === total - 1 || Math.abs(i - current) <= delta) {
        pages.push(i);
      }
    }

    return pages.reduce<(number | "...")[]>((acc, page) => {
      if (acc.length === 0) return [page];
      const prev = acc[acc.length - 1];
      if (typeof page === "number" && typeof prev === "number") {
        if (page - prev > 1) acc.push("...");
      }
      acc.push(page);
      return acc;
    }, []);
  };

  return (
    <div className="mt-8 flex flex-wrap items-center justify-center gap-2">
      {/* Prev */}
      <button
        disabled={currentPage === 0}
        onClick={() => onPageChange(currentPage - 1)}
        className="px-3 py-1.5 rounded-md border text-sm disabled:opacity-50"
      >
        Prev
      </button>

      {getVisiblePages(currentPage, totalPages).map((p, idx) =>
        p === "..." ? (
          <span key={`dots-${idx}`} className="px-2 text-gray-400">
            …
          </span>
        ) : (
          <button
            key={p}
            onClick={() => onPageChange(p)}
            className={`min-w-[36px] px-3 py-1.5 rounded-md text-sm ${
              p === currentPage ? "bg-black text-white" : "border hover:bg-gray-100"
            }`}
          >
            {p + 1}
          </button>
        )
      )}

      {/* Next */}
      <button
        disabled={currentPage === totalPages - 1}
        onClick={() => onPageChange(currentPage + 1)}
        className="px-3 py-1.5 rounded-md border text-sm disabled:opacity-50"
      >
        Next
      </button>
    </div>
  );
};

export default Pagination;
